document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#MainNav');
  const root = window.Shopify?.routes?.root || '/';
  const sections = 'cart-drawer,main-cart';
  let drawerOpenedAt = 0;

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('open', !open);
    });
  }

  const getDrawer = () => document.querySelector('.cart-drawer-panel');

  const openDrawer = () => {
    drawerOpenedAt = Date.now();
    document.documentElement.classList.add('cart-open');
    document.body.classList.add('cart-open');
    const drawer = getDrawer();
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    document.documentElement.classList.remove('cart-open');
    document.body.classList.remove('cart-open', 'cart-pending');
    const drawer = getDrawer();
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  };

  const setCartCount = (value) => {
    if (value === undefined || value === null || Number.isNaN(Number(value))) return;
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = String(value);
    });
  };

  const parseSection = (html, selector) => {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const applyCartSections = (payload) => {
    const returned = payload?.sections || {};
    const newDrawer = parseSection(returned['cart-drawer'], '[data-cart-drawer-shell]');
    const currentDrawer = document.querySelector('[data-cart-drawer-shell]');
    if (newDrawer && currentDrawer) {
      const newCount = newDrawer.querySelector('[data-cart-total-count]');
      const currentCount = currentDrawer.querySelector('[data-cart-total-count]');
      if (newCount && currentCount) currentCount.textContent = newCount.textContent;

      const newContent = newDrawer.querySelector('.cart-drawer-content');
      const currentContent = currentDrawer.querySelector('.cart-drawer-content');
      if (newContent && currentContent) currentContent.replaceWith(newContent);

      const newFooter = newDrawer.querySelector('.cart-drawer-footer');
      const currentFooter = currentDrawer.querySelector('.cart-drawer-footer');
      if (newFooter && currentFooter) currentFooter.replaceWith(newFooter);
      else if (currentFooter) currentFooter.remove();
      else if (newFooter) currentDrawer.querySelector('.cart-drawer-panel')?.append(newFooter);
    }

    const newCartPage = parseSection(returned['main-cart'], '.cart-page');
    const currentCartPage = document.querySelector('.cart-page');
    if (newCartPage && currentCartPage) currentCartPage.replaceWith(newCartPage);

    const renderedCount = document.querySelector('[data-cart-total-count]');
    setCartCount(payload?.item_count ?? renderedCount?.textContent);
  };

  const refreshCartFallback = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    setCartCount(cart.item_count);
  };

  const changeCart = async (key, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity,
        sections,
        sections_url: window.location.pathname
      })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    return response.json();
  };

  document.addEventListener('click', async (event) => {
    const earlyCheckout = event.target.closest('.cart-drawer-footer button[name="checkout"]');
    if (earlyCheckout && Date.now() - drawerOpenedAt < 600) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const cartToggle = event.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const drawerChange = event.target.closest('[data-cart-change]');
    const pageRemove = event.target.closest('[data-cart-page-remove]');
    const control = drawerChange || pageRemove;
    if (!control || control.disabled) return;

    event.preventDefault();
    const line = control.closest('.cart-drawer-line, .cart-items article');
    const quantityNode = line?.querySelector('.drawer-quantity span, .cart-page-qty input');
    const currentQuantity = Number(quantityNode?.value || quantityNode?.textContent || 1);
    const quantity = pageRemove ? 0 : Number(control.dataset.cartQuantity);
    const countElement = document.querySelector('[data-cart-count]');
    const currentCount = Number(countElement?.textContent || 0);

    control.disabled = true;
    line?.classList.add(quantity === 0 ? 'is-removing' : 'is-updating');
    setCartCount(Math.max(0, currentCount + quantity - currentQuantity));
    document.body.classList.add('cart-pending');

    try {
      const cart = await changeCart(control.dataset.cartKey, quantity);
      applyCartSections(cart);
      if (drawerChange) openDrawer();
    } catch (error) {
      line?.classList.remove('is-removing', 'is-updating');
      control.disabled = false;
      await refreshCartFallback();
    } finally {
      document.body.classList.remove('cart-pending');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains('cart-open')) closeDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const drawerCheckout = event.target.closest('.cart-drawer-footer form');
    if (drawerCheckout && Date.now() - drawerOpenedAt < 600) {
      event.preventDefault();
      return;
    }

    const form = event.target.closest('form.ajax-cart-form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const originalLabel = button.textContent;
    const formData = new FormData(form);
    formData.set('sections', sections);
    formData.set('sections_url', window.location.pathname);

    button.disabled = true;
    button.setAttribute('aria-live', 'polite');
    button.textContent = 'Adding...';
    form.classList.add('is-adding');
    const mobileAdd = window.matchMedia('(max-width: 750px)').matches;
    document.body.classList.add('cart-pending');
    if (!mobileAdd) openDrawer();

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (!response.ok) throw new Error('Unable to add item');

      const added = await response.json();
      applyCartSections(added);
      if (!mobileAdd) openDrawer();
      button.textContent = 'Added';
      form.classList.add('is-added');
    } catch (error) {
      button.textContent = 'Try again';
      form.classList.add('has-error');
      await refreshCartFallback();
    } finally {
      document.body.classList.remove('cart-pending');
      form.classList.remove('is-adding');
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalLabel;
        form.classList.remove('is-added', 'has-error');
      }, 900);
    }
  }, true);
});
